import request from '@/utils/request'

/**
 * 根据物品和状态查找流程数据
 * @param article
 * @param status
 * @returns {AxiosPromise}
 */
export function getResourceBorrowingInfoByArticle(article, status) {
    return request({
        url: `/api/ResourceBorrowing/getResourceBorrowingInfoByArticle`,
        method: 'post',
        data:{
            article: article,
            status:status
        }
    })
}

/**
 * 查询所有申请的流程(除归还)
 * @returns {AxiosPromise}
 */
export function getAllBorrowingInformation() {
    return request({
        url: `/api/ResourceBorrowing/getAllBorrowingInformation`,
        method: 'get',
    })
}

/**
 * 根据企业微信id查询流程
 * @param {Object} approvalNo
 */
export function getBorrowingInformationForApprovalNo(approvalNo) {
    return request({
        url: `/api/ResourceBorrowing/${approvalNo}/getBorrowingInformationForApprovalNo`,
        method: 'get',
    })
}

/**
 * 查询所有拿取人信息
 * @returns {AxiosPromise}
 */
export function getReturneeInformation() {
    return request({
        url: `/api/ResourceBorrowing/getReturneeInformation`,
        method: 'get',
    })
}

/**
 * 填充借用者信息
 * @param data
 * @returns {AxiosPromise}
 */
export function borrowingInformationFill(data) {
    return request({
        url: `/api/ResourceBorrowing/borrowingInformationFill`,
        method: 'post',
        data: data
    })
}

/**
 * 填充多个借用者信息
 * @param data
 * @returns {*}
 */
export function borrowingInformationsFill(data) {
    return request({
        url: `/api/ResourceBorrowing/borrowingInformationsFill`,
        method: 'post',
        data: data
    })
}

/**
 * 填充多个借用者信息
 * @param data
 * @returns {*}
 */
export function borrowingInformationsFillT(data) {
    return request({
        url: `/api/ResourceBorrowing/borrowingInformationsFillT`,
        method: 'post',
        data: data
    })
}

export function receiverInformationFillForTemporary(data){
	return request({
	    url: `/api/ResourceBorrowing/receiverInformationFillForTemporary`,
	    method: 'post',
	    data: data
	})
}

/**
 * 填充拿取者信息
 * @param id
 * @param data
 * @returns {AxiosPromise}
 */
export function receiverInformationFill(id, data) {
    return request({
        url: `/api/ResourceBorrowing/${id}/receiverInformationFill`,
        method: 'post',
        data: data
    })
}

/**
 * 填充归还者信息
 * @param id
 * @param data
 * @returns {AxiosPromise}
 */
export function returneeInformationFill(id, data) {
    return request({
        url: `/api/ResourceBorrowing/${id}/returneeInformationFill`,
        method: 'post',
        data: data
    })
}

/**
 * 根据物品名称和时间获取对应流程数据
 * @param EquipmentName
 * @param StartTime
 * @param EndTime
 * @returns {AxiosPromise}
 */
export function getBorrowingInformationByTime(EquipmentName, StartTime, EndTime) {
    return request({
        url: `/api/ResourceBorrowing/getBorrowingInformationByTime?EquipmentName=${EquipmentName}&StartTime=${StartTime}&EndTime=${EndTime}`,
        method: 'get',
    })
}

/**
 * @param {Object} startTime 开始时间
 * @param {Object} endTime 结束时间
 * @param {Object} eName 物品名称
 */
export function CheckTimeSlot(startTime,endTime,eName){
	return request({
	    url: `/api/ResourceBorrowing/check-timeslot?startTime=${startTime}&endTime=${endTime}&eName=${eName}`,
	    method: 'get',
	})
}

/**
 * 根据申请人查询其全部的违规记录
 * @returns {AxiosPromise}
 */
export function getViolationRecordAllAndCount(empName) {
    return request({
        url: `/api/ResourceBorrowing/${empName}/getViolationRecordAllAndCount`,
        method: 'get',
    })
}

/**
 * 根据申请人查询拿取未归还且违规的数据
 * @param {String} empNo 
 * @returns {AxuisPromise} 
 */
export function getViolationTake(empNo) {
    return request({
        url: `/api/ResourceBorrowing/${empNo}/getViolationTake`,
        method: 'get',
    })
}

/**
 * 通过工号校验其是否有权限申请
 * @param {String} empNo
 * @returns {AxuisPromise}
 */
export function checkByEmpNo(empNo) {
    return request({
        url: `/api/ResourceBorrowing/${empNo}/CheckByEmpNo`,
        method: 'post',
    })
}

/**
 * 根据结束时间获取违规时间
 * @param empNo
 * @param endTime
 * @returns {*}
 */
export function getViolationTime(empNo,endTime) {
    return request({
        url: `/api/ResourceBorrowing/${empNo}/${endTime}/getViolationTime`,
        method: 'get',
    })
}

/**
 * 根据多个结束时间获取违规时间
 * @param empNo 工号
 * @param data  结束时间
 * @returns {*}
 */
export function getViolationTimes(empNo,data) {
    return request({
        url: `/api/ResourceBorrowing/${empNo}/getViolationTimes`,
        method: 'post',
        data: data
    })
}

/**
 * =========会议室============
 */

/**
 * 查询剩余的会议室名称
 * @returns {AxiosPromise}
 */
export function getRemainingMeetingRoomName() {
    return request({
        url: `/api/MeetingRoomArticle/getRemainingMeetingRoomName`,
        method: 'get',
    })
}

/**
 * 填充拿取者信息
 * @param data
 * @returns {AxiosPromise}
 */
export function conferenceRoomTakeFill(data) {
    return request({
        url: `/api/MeetingRoomArticle/conferenceRoomTakeFill`,
        method: 'post',
        data: data
    })
}

/**
 * 获取全部拿取人信息
 * @returns {AxiosPromise}
 */
export function getMeetingRoomArticleOfTake() {
    return request({
        url: `/api/MeetingRoomArticle/getMeetingRoomArticleOfTake`,
        method: 'get',
    })
}

/**
 * 填充归还者信息
 * @param id
 * @param data
 * @returns {AxiosPromise}
 * @constructor
 */
export function conferenceRoomBackFill(id, data) {
    return request({
        url: `/api/MeetingRoomArticle/${id}/ConferenceRoomBackFill`,
        method: 'post',
        data: data
    })
}

//============黑名单============
export function getBlackListByEmpNo(empNo) {
    return request({
        url: `/api/ResourceBorrowing/${empNo}/getBlackListByEmpNo`,
        method: 'post',
    })
}